import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/services';
import { Helpers } from 'src/app/helpers';

@Component({
    selector: 'medpt-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    standalone: false
})
export class PageNotFoundComponent implements OnInit {
  dashboardUrl: string = "";
  constructor(private loaderService: LoaderService) {
    this.dashboardUrl = Helpers.getApplicationUrl() + "/Dashboard";
  }

  ngOnInit(): void {
    this.loaderService.hideLoader();
  }

}
